<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="attach-images-top-level">
	<attached-images-tool-bar></attached-images-tool-bar>

	<div [ngClass]="{ 'full-screen-scroller': !attachedFilesService.ticketContext.fixedDimensionsUI }">
		<!-- These share the same real estate -->
		<image-list-view
			*ngIf="(attachedFilesService.viewState$ | async) !== attachmentsViewState.FileCarouselView"
			class="full-height"
			automationId="imageList"
			[acceptedFileExtensions]="attachedFilesService.acceptedFileExtension$ | async"
			[fileSizeLimit]="attachedFilesService.fileSizeLimit$ | async"
		>
		</image-list-view>

		<selected-image-view
			*ngIf="(attachedFilesService.viewState$ | async) === attachmentsViewState.FileCarouselView"
			class="full-height"
		>
		</selected-image-view>
	</div>
</div>
